import { useEffectOnce } from 'react-use';
import { disableAdvertisingProfilePromoEnabled } from '../../../utils/useAdvertisingPromoEnabled';
import { Flex } from '../../layout/Flex';
import { AdvertisingButton } from '../AdvertisingButton/AdvertisingButton';
import { AdvertisingPromoTooltip } from '../AdvertisingPromoTooltip/AdvertisingPromoTooltip';
import { AdvertisingPromoButtonWithTooltipProps } from './types';

export const AdvertisingPromoButtonWithTooltip: React.FC<AdvertisingPromoButtonWithTooltipProps> = (
    props,
) => {
    const { promo, width } = props;

    useEffectOnce(() => {
        disableAdvertisingProfilePromoEnabled();
    });

    if (!promo) {
        return <AdvertisingButton {...props} />;
    }

    return (
        <AdvertisingPromoTooltip
            trigger={
                <Flex width={width} flexGrow="1">
                    <AdvertisingButton {...props} width="100%" color="accent" />
                </Flex>
            }
        />
    );
};
